import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import enTranslations from './i18n/en.json';
import seTranslations from './i18n/se.json';

type JeevesAmazonFinanceLanguage = 'en' | 'se';

@Injectable()
export class JeevesAmazonFinanceTranslationsService {
  private readonly translations: Record<JeevesAmazonFinanceLanguage, Record<string, string>> = {
    en: enTranslations,
    se: seTranslations
  };

  constructor(private readonly translate: TranslateService) {}

  register(): void {
    this.mergeTranslations(this.translate.currentLang);
    this.translate.onLangChange.subscribe(event => this.mergeTranslations(event.lang));
  }

  private mergeTranslations(lang: string): void {
    const erpTranslations = this.translations[lang as JeevesAmazonFinanceLanguage];
    if (!erpTranslations) return;

    this.translate.setTranslation(lang, erpTranslations, true);
  }
}
